import { CustomButton } from '../CustomButton/CustomButton';

import styles from './deleteDocumentModal.module.css';
import IconBin from './IconLöschen.svg';

interface DeleteDocumentModalProps {
    isOpen: boolean;
    isDeleting: boolean;
    onClose: () => void;
    onDelete: () => void
}
export const DeleteDocumentModal = ({ isOpen, isDeleting, onClose, onDelete }: DeleteDocumentModalProps) => {

    if (!isOpen) return null;
    return (
        <div className={styles.modalOverlay}>
            <div className={styles.modalContent}
                onClick={(e) => e.stopPropagation()}>
                <img className={styles.icon} src={IconBin} />
                <p className={styles.title}>Dokument löschen?</p>
                <p className={styles.text}>Sind Sie sicher, dass Sie dieses Dokument löschen möchten? <strong>Hinweis:</strong> Das Entfernen des Dokuments kann bei unsachgemäßer Handhabung zu Verletzungen führen.</p>
                <CustomButton loading={isDeleting} onClick={onDelete} color='red' width={100} customClass={styles.button}>Ja, löschen</CustomButton>
                <CustomButton onClick={onClose} color='gray' width={100}>Abbrechen</CustomButton>
            </div>

        </div>
    )
}